import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGE_RENDER_TYPE, SIDEMENU_MODE } from 'e3-common/constants/enumerates';
import { E3Input } from 'e3-components';
import layoutStyles from './Layout.module.css';
import styles from './SideMenu.module.css';
import SideMenuFavoriteTab from './SideMenuFavoriteTab';
import SideMenuSearchTab from './SideMenuSearchTab';
import SideMenuMainTab from './SideMenuMainTab';

import { useBoundStore } from 'e3-common/store/useBoundStore';
import { shallow } from 'zustand/shallow';
import useFetch from 'e3-common/hooks/useFetch';
import { LOCAL_STORAGE_KEYS } from 'e3-common/constants/enumerates';
import { setLocalStorageItem } from 'e3-common/utils/localStorageUtil';

const SideMenu = () => {
    const tabMenuList = useBoundStore((state) => state.tabMenu.menuList);
    const { menuList, pageRenderType, setSelectedMenu, showTopMenuYn, selectedTopMenu } =
        useBoundStore((state) => state.menu, shallow);

    const refSearch = useRef();
    const [sideMenuMode, setSideMenuMode] = useState(SIDEMENU_MODE.MENU);
    const [width, setWidth] = useState(0);
    const [show, setShow] = useState(false);
    const [searchMenuRslt, setSearchMenuRslt] = useState([]);
    const { request } = useFetch();

    const navigate = useNavigate();

    const onMenuHide = () => {
        setWidth(0);
        searchMenu(false);
    };

    const onMenuShow = () => {
        setWidth(230);
    };

    const onSideMenuMode = (mode) => {
        setSideMenuMode(mode);
    };

    const onMenuClick = (d) => {
        if (d) {
            // search menu close
            setShow(false);
            refSearch.current.clear();
            // 그리드 개인화 기능을 위한 메뉴ID 인식.
            setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_ID, d.menuId);

            setSelectedMenu({
                menuId: d.menuId,
                menuName: d.menuName,
                sideYn: d.sideYn,
                displayYn: d.displayYn,
                menuNameList: d.menuNameList,
            });
            if (d.programRoutePath) {
                navigate(import.meta.env.VITE_PUBLIC_URL + d.programRoutePath);

                let chk = tabMenuList.filter((x) => {
                    return x.menuId === d.menuId;
                });

                if (!chk.length) {
                    const param = { PGM_ID: d.menuId };

                    const backendType = import.meta.env.VITE_BACKEND_TYPE; // JAVA or DOTNET
                    if (backendType === 'DOTNET') {
                        // request(`/menuLog`, { method: 'post', body: param });
                    }
                }
            }
        }
    };

    const searchMenu = async (b) => {
        const value = refSearch.current.getValue();
        setShow(b);
        if (b) {
            const rslt = menuList.filter((x) => {
                return x.menuName.toLowerCase().search(value.toLowerCase()) !== -1;
            });
            setSearchMenuRslt(rslt);
        } else {
            refSearch.current.clear();
        }
    };

    const changeValue = () => {
        if (!refSearch.current.getValue()) {
            setShow(false);
        }
    };

    useEffect(() => {
        if (menuList?.length > 0) {
            onMenuShow();
        } else {
            onMenuHide();
        }
    }, [menuList]);

    return (
        <div className={layoutStyles.sidemenu}>
            <div className={`${styles.nav} ${width === 0 ? styles.invisible : styles.visible}`}>
                <div className={styles.menuSearch}>
                    <E3Input
                        ref={refSearch}
                        type={'search'}
                        className={styles.transSearch}
                        placeholder={'Search'}
                        onEnterPress={() => searchMenu(true)}
                        onKeyUp={changeValue}
                    />
                    <button
                        className={styles.btnMenuSearch}
                        onClick={() => searchMenu(true)}
                    ></button>
                    {show ? (
                        <div className={styles.searchResultList}>
                            {searchMenuRslt?.length ? (
                                <ul>
                                    {searchMenuRslt?.map((x) => {
                                        return (
                                            <li key={x.menuId} onClick={() => onMenuClick(x)}>
                                                <span>{x.menuName}</span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <>
                                    <ul></ul>
                                    <span className={styles.noSearchResult}>
                                        검색된 메뉴가 없습니다.
                                    </span>
                                </>
                            )}

                            <div className={styles.searchFooter}>
                                <div className={styles.searchNum}>
                                    <span>{searchMenuRslt.length}</span>건이 검색되었습니다.
                                </div>
                                <div
                                    className={styles.searchClose}
                                    onClick={() => searchMenu(false)}
                                >
                                    닫기
                                </div>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>

                {/* 일반 메뉴 리스트 */}
                <SideMenuMainTab
                    sideMenuMode={sideMenuMode}
                    showAllMenuInSide={showTopMenuYn === 'Y' ? false : true}
                    onMenuClick={onMenuClick}
                />

                {/* 즐겨찾기 */}
                <SideMenuFavoriteTab sideMenuMode={sideMenuMode} onMenuClick={onMenuClick} />

                {/* 메뉴 검색 */}
                <SideMenuSearchTab sideMenuMode={sideMenuMode} onMenuClick={onMenuClick} />
            </div>

            {/* sidemenu 열기/닫기 버튼 */}
            <div className={styles.sidemenuLine}>
                <div className={styles.tabBg}></div>
                {width === 0 ? (
                    <span className={styles.sidemenuOpenControl} onClick={onMenuShow}></span>
                ) : (
                    <span className={styles.sidemenuCloseControl} onClick={onMenuHide}></span>
                )}
                {/* 열기버튼 open/ 닫기버튼  close */}
            </div>
        </div>
    );
};

SideMenu.displayName = 'SideMenu';
export default SideMenu;
